var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{attrs:{"description":"二维码失效了"}})
}
var staticRenderFns = []

export { render, staticRenderFns }